import React, { Fragment } from 'react';

function ExhibitIntroPara() {
  return (
    <Fragment>
      We are building this technology platform into several existing exhibit experiences at the
      Center of Science and Industry (COSI) in Columbus, Ohio and the Science Museum of Minnesota in
      Saint Paul, Minnesota.
    </Fragment>
  );
}

export default ExhibitIntroPara;
